<div class="p-fluid p-formgrid grid mt-5">
        <ng-container>
            <div class="field col-12 -mb-5">
                <h4>{{ fieldJson?.titulo }}</h4>
                @for (err of errors; track errors) {
                    <p-messages [severity]="err.type" *ngIf="!validarErroresPasos(fieldJson)">
                        <ng-template pTemplate>
                            <div class="ml-2 text-xl w-full">{{ err.value }}
                            </div>
                        </ng-template>
                    </p-messages>
                }
            </div>
            @for (component of fieldJson.components; track fieldJson.components){
                @if(component.controlType && isValidControlType(component.controlType)){
                    <div class="field col-12 md:col-10 lg:col-3 mt-1">
                        <app-components-pasos [component]="component" [form]="form" [step]="fieldJson.step" (onEmitterSelectDropdown)="onEmitterSelectDropdown($event)"
                                              (onEmitterInputNumber)="onEmitterInputNumber($event)"></app-components-pasos>
                    </div>
                }
            }
        </ng-container>

        <div *ngIf="fieldJson?.step!==1 && fieldJson?.typeStep=='uniqueForm' || !fieldJson?.disableComponent"
             class="field col-12 lg:col-9 md:col-10 sm:col-9 xs:col-8 -mt-3 xl:h-5rem lg:h-5rem md:h-9rem sm:h-20rem xs:h-19rem">
            <shared-consulta-usuario #consultaUsuario [typeFilter]="1"[typeActionTo]="TipoAutorizaciones.Persona" [cardStyle]="'col-12'"
                                     (onResponseUserEmitter)="setOnResponseUserEmitter($event)"></shared-consulta-usuario>
        </div>
        <!--  Mostrar template de componete hijo que se desea reutilizarse en otra parte del template, muestra la informacion de respuesta de los datos que se ingresa-->
       <div class="field col-12" *ngIf="this.templateResponse">
           <ng-container *ngTemplateOutlet="this.templateResponse"></ng-container>
       </div>

        <div class="field col-12 md:col-5 -mt-3" *ngIf="this.dropdown || fieldJson?.step==3">
            <div class="flex flex-row mb-3" *ngIf="tituloFileUpload !== ''">
                <label><b>{{ tituloFileUpload }}</b></label>
            </div>
            <div class="flex flex-row">
                <p-fileUpload [maxFileSize]="this.fileUtilsService.maxFileSize" [auto]="true" customUpload="true"
                              #cargaArchivos id="cargaArchivos" mode="basic"
                              chooseLabel="Cargar archivo" chooseIcon="pi pi-upload"
                              (uploadHandler)="onFileUpload($event)"
                              name="demo[]" accept="{{this.fileUtilsService.formatoArchivo}}" class="mr-3"
                              [disabled]="validacionButton()"
                              [pTooltip]="validacionButton()?'':'Seleccione el archivo con formato: '+this.fileUtilsService.formatoArchivo"
                              invalidFileTypeMessageDetail="Adjuntar un archivo con un formato compatible {{this.fileUtilsService.formatoArchivo}}"
                              invalidFileTypeMessageSummary="Formato inválido"
                              invalidFileSizeMessageSummary="Archivo demasiado grande"
                              invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 1000000 }} MB"></p-fileUpload>
                <div class="flex flex-column align-items-center justify-content-center" style="margin-bottom: 20px;"
                     *ngIf="personasService.selected() && personasService.selected()?.uniqueId != null && fieldJson?.step!=4 && !this.personasService.validStatuConsultaPorTitular()">
                    <p-tag severity="info" [value]="'('+countFile()+') archivos'"
                           styleClass="p-clickable cursor-pointer"
                           [style]="{ 'font-size': '12px', 'padding': '3px' }"
                           [pTooltip]="'Archivos vigentes'" (click)="openDialogFile()"/>
                </div>
                <div class="flex flex-column align-items-center justify-content-center">
                    <p-button icon="pi pi-info"
                              styleClass="w-3rem h-3rem p-button-info p-button-outlined p-button-rounded mb-2"
                              [pTooltip]="informacion!==''?informacion:''"></p-button>
                    <span class="font-bold text-sm">Información</span>
                </div>
            </div>
            <div class="flex flex-row mt-3"
                 *ngIf="showCargarEscritura && idDropdown=='3' && fieldJson?.step == 2">
                <label>¿No posees el registro de la escritura?
                    Solicítala <a href="https://www.e.cnr.gob.sv/ServiciosOL/" target="_blank">aquí</a></label>
            </div>
        </div>

    <ng-container *ngIf="fieldJson?.typeStep=='uniqueForm' || !fieldJson?.disableComponent">
        <div class="field col-12">
            <app-personas-proyecto-table [personas]="draftProjectService.draftProject().tenenciaLegal"
                                         [paso]="fieldJson?.step!"
            ></app-personas-proyecto-table>
            <small style="color:red" class="ng-dirty ng-invalid"
                   *ngIf="fieldJson?.step && this.draftProjectService.countTenenciaByStep()==0">
                <b *ngIf="fieldJson?.pieValidTable!==''">{{ fieldJson?.pieValidTable }}</b>
            </small>
        </div>
    </ng-container>
</div>

<!--Dialog que muestra los archivos-->
<ng-container *ngIf="openDialog">
    <app-archivo-vigente
        [openDialog]="openDialog"
        [archivoItems]="this.personasService.archivos()"
        (onEventEmitterClose)="onDialogClosed($event)"
        (onEventEmitterFile)="onFileCheck($event)"
        [datosCargados]="personasService.archivosLoad">
    </app-archivo-vigente>
</ng-container>



